import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Bundled translations from submodule
import translationsEn from '@translations/translations/desktop_en.json';
import translationsFr from '@translations/translations/desktop_fr.json';

// Type sources: generated from submodule JSON
import type {
  DesktopCallsTranslations,
  DesktopCommonTranslations,
  DesktopInputsTranslations,
  DesktopLoginTranslations,
  DesktopUiTranslations,
} from './i18n-resources';

type DesktopNamespace =
  | 'desktop_common'
  | 'desktop_ui'
  | 'desktop_login'
  | 'desktop_inputs'
  | 'desktop_calls';

const DESKTOP_NAMESPACES: DesktopNamespace[] = [
  'desktop_common',
  'desktop_ui',
  'desktop_login',
  'desktop_inputs',
  'desktop_calls',
];

const pickDesktopKeys = (translations: Record<string, unknown>): Record<string, unknown> => {
  const result: Record<string, unknown> = {};
  for (const ns of DESKTOP_NAMESPACES) {
    if (translations[ns]) {
      result[ns] = translations[ns];
    }
  }
  return result;
};

const resources = {
  en: pickDesktopKeys(translationsEn) as Record<string, Record<string, string>>,
  fr: pickDesktopKeys(translationsFr) as Record<string, Record<string, string>>,
};

export const supportedLngs = Object.keys(resources);
export type Locale = 'en' | 'fr';

const getUserLang = (): Locale => {
  const currentNavigatorLanguage =
    localStorage.getItem('allo:settings:locale') ?? navigator.language.split('-')[0];

  if (currentNavigatorLanguage && supportedLngs.includes(currentNavigatorLanguage)) {
    return currentNavigatorLanguage as Locale;
  }

  const firstNavigatorLanguage = navigator.languages[0]?.split('-')[0];

  if (firstNavigatorLanguage && supportedLngs.includes(firstNavigatorLanguage)) {
    return firstNavigatorLanguage as Locale;
  }

  return 'en';
};

export const userLang = getUserLang();

i18n.use(initReactI18next).init({
  supportedLngs,
  resources,
  fallbackLng: 'en',
  lng: userLang,
  interpolation: {
    escapeValue: false,
  },
});

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'desktop_common';
    resources: {
      desktop_common: DesktopCommonTranslations;
      desktop_inputs: DesktopInputsTranslations;
      desktop_login: DesktopLoginTranslations;
      desktop_ui: DesktopUiTranslations;
      desktop_calls: DesktopCallsTranslations;
    };
  }
}
